function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgCertificado = function SvgCertificado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9.25 24.482c0 .501-.403.91-.904.91H5.314c-.501 0-.903-.409-.903-.91v-2.497l-.31-1.518a4.7 4.7 0 01-.094-.934v-4.03c0-.56.1-1.115.296-1.638l.143-.383H3.403a.909.909 0 01-.88-1.117l.306-1.326a1.31 1.31 0 011.273-1.021h1.503l1.412-2.876A2.915 2.915 0 019.629 5.5h12.135c1.109 0 2.12.637 2.614 1.642l1.412 2.876h1.503a1.31 1.31 0 011.272 1.021l.306 1.326a.909.909 0 01-.88 1.117h-1.043l.143.383c.196.523.296 1.078.296 1.637a.5.5 0 01-1 0c0-.44-.079-.876-.232-1.287l-.396-1.058a.5.5 0 01.468-.675h1.644l-.28-1.218a.31.31 0 00-.298-.246h-1.815a.5.5 0 01-.449-.28L23.48 7.582A1.915 1.915 0 0021.765 6.5H9.629c-.724 0-1.389.418-1.715 1.082l-1.549 3.156a.5.5 0 01-.449.28H4.102a.31.31 0 00-.298.246l-.281 1.218h1.644a.5.5 0 01.468.675l-.395 1.058c-.154.41-.233.847-.233 1.287v4.031c0 .247.025.493.074.735l.137.673c1.996.427 3.992.731 5.987.912a.5.5 0 01-.09.996 50.43 50.43 0 01-1.866-.204v1.837zm-3.84-2.479v2.39h2.84v-1.887a51.878 51.878 0 01-2.84-.503zm3.801-4.85a.5.5 0 11.898-.442l.568 1.158a.5.5 0 01-.449.72H6.927a.5.5 0 110-1h2.499l-.215-.437zm2.135 3.508a.5.5 0 110-1h1a.5.5 0 110 1h-1zm-2-8a.5.5 0 110-1h12.5a.5.5 0 110 1h-12.5zM24.857 26.15l.03.032 3.288 4a.5.5 0 11-.772.636l-3.29-4a.506.506 0 01-.027-.038 6.044 6.044 0 01-3.45 1.077c-2.398 0-4.545-1.41-5.57-3.612-.281-.765-.452-1.345-.513-1.755-.06-.406-.06-.983-.003-1.741l.003-.033c.43-3.058 3.014-5.359 6.083-5.359 3.396 0 6.146 2.8 6.146 6.25 0 1.789-.74 3.403-1.925 4.543zm-9.314-3.806c.048.326.202.85.445 1.517.848 1.816 2.644 2.996 4.648 2.996 2.84 0 5.146-2.348 5.146-5.25 0-2.901-2.306-5.25-5.146-5.25-2.56 0-4.723 1.921-5.09 4.482-.05.683-.05 1.189-.003 1.505z"
  }));
};
SvgCertificado.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgCertificado.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgCertificado;